export enum FeatureFlag {
  AccountConfirmationAutosave = 'flagAccountConfirmationAutosave',
  AdvisorOnboarding = 'flagAdvisorOnboarding',
  AdvisorSurveysAdmin = 'flagAdvisorSurveysAdmin',
  CockpitNonEci = 'flagCockpitNonEci',
  AdvisorDirectory = 'flagAdvisorDirectory',
  AiExperienceOptIn = 'ai_experience_opt_in',
  ClientPortalRedesignAccountProfile = 'flagClientPortalRedesignAccountProfile',
  ClientPortalRedesignAccounts = 'flagClientPortalRedesignAccounts',
  ClientPortalRedesignDocuments = 'flagClientPortalRedesignDocuments',
  ClientPortalRedesignHome = 'flagClientPortalRedesignHome',
  ClientPortalRedesignInvestments = 'flagClientPortalRedesignInvestments',
  ClientPortalRedesignOnboarding = 'flagClientPortalRedesignOnboarding',
  ClientPortalRedesignPlanning = 'flagClientPortalRedesignPlanning',
  ClientPortalRedesignShell = 'flagClientPortalRedesignShell',
  ClientPortalRedesignSupport = 'flagClientPortalRedesignSupport',
  ClientPortalRedesignTasks = 'flagClientPortalRedesignTasks',
  ClientPortalRedesignTax = 'flagClientPortalRedesignTax',
  ClientPortalRedesignYourTeam = 'flagClientPortalRedesignYourTeam',
  ExtendDocumentExtractionPollingEnabled = 'flagExtendDocumentExtractionPollingEnabled',
  FlagServalSupport = 'flagServalSupport',
  GoldmanSachsCustodian = 'flagGoldmanSachsCustodian',
  InvestmentProposalsUploadFile = 'investmentProposalsUploadFile',
  InvestmentPortfolioReportingEmbed = 'flagSwimPortfolioReportingEmbedUserIds',
  InvestmentResearch = 'flagInvestmentResearch',
  LinkedBankAdvisorImport = 'flagLinkedBankAdvisorImport',
  ManagedInvestmentsImprovements = 'managedInvestmentsImprovements',
  PortfolioPageRevamp = 'flagPortfolioPageRevamp',
  RetirementPlans = 'flagRetirementPlans',
  SchwabApiSync = 'flagSchwabApiSync',
  ServiceItems = 'service-items',
  SkewAutoReload = 'flagSkewAutoReload',
  TasksRevamp = 'flagTasksRevamp',
  TasksRevampAll = 'flagTasksRevampAll',
}
